import React from 'react';

import {BoxScoresWidgetProps} from "../models/box-scores-widget.props";
import {BoxScoresWidgetController} from "../box-scores-widget.controller";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {BoxScoresWidgetContent} from "./box-scores-widget.content";

export class BoxScoresWidgetComponentProps extends BoxScoresWidgetProps {}

export const BoxScoresWidgetComponent = ({controller}: BoxScoresWidgetComponentProps) => {
  return <BoxScoresWidgetContent controller={controller}/>
};

const settings: ComposeSettings = {
  component: BoxScoresWidgetComponent,
  propsType: BoxScoresWidgetComponentProps,
  controllerType: BoxScoresWidgetController,

  createModule: true,
  observe: true,
}

export default Compose(settings);

